// import React, { useState, useEffect, useRef } from 'react';
// import './BookingForm.css';

// const tabLabels = [
//   { icon: 'fas fa-hotel', label: 'HOTEL STAY' },
//   { icon: 'fas fa-building', label: 'APARTMENT STAY' },
//   { icon: 'fas fa-house-user', label: 'GUEST HOUSE' },
//   { icon: 'fas fa-bed', label: 'HOSTELS' }
// ];

// const BookingForm = () => {
//   const [activeTab, setActiveTab] = useState(0);
//   const [popupVisible, setPopupVisible] = useState(false);
//   const [counts, setCounts] = useState({ rooms: 1, adults: 2, children: 0 });
//   const popupRef = useRef();

//   const updateCount = (type, delta) => {
//     setCounts(prev => {
//       const newCount = Math.max(type === 'rooms' ? 1 : 0, prev[type] + delta);
//       return { ...prev, [type]: newCount };
//     });
//   };

//   const handleClickOutside = (e) => {
//     if (popupRef.current && !popupRef.current.contains(e.target)) {
//       setPopupVisible(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   const renderForm = () => (
//     <>
//       <div className="input-group1">
//         <i className="fas fa-search"></i>
//         <input type="text" placeholder="Where would you like to go?" />
//       </div>
//       <div className="date-row1">
//         <div className="input-group1" style={{width:"50%"}}>
//           <i className="fas fa-calendar-alt"></i>
//           <input type="date" defaultValue="2025-07-10" />
//         </div>
//         <div className="input-group1" style={{width:"50%"}}>
//           <i className="fas fa-calendar-check"></i>
//           <input type="date" defaultValue="2025-07-11" />
//         </div>
//       </div>
//       <div className="room-info1" onClick={() => setPopupVisible(!popupVisible)}>
//         <span>
//           {counts.rooms} Room{counts.rooms > 1 ? 's' : ''}, {counts.adults} Adult{counts.adults > 1 ? 's' : ''}, {counts.children} Children
//         </span>
//         {popupVisible && (
//           <div className="popup1" ref={popupRef}>
//             {['rooms', 'adults', 'children'].map((type) => (
//               <div className="counter1" key={type}>
//                 <span>{type.charAt(0).toUpperCase() + type.slice(1)}</span>
//                 <div>
//                   <button onClick={() => updateCount(type, -1)}>-</button>
//                   <span>{counts[type]}</span>
//                   <button onClick={() => updateCount(type, 1)}>+</button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//       <button className="search-btn1">SEARCH</button>
//     </>
//   );

//   return (
//     <div className="container1">
//       <div className="tabs1">
//         {tabLabels.map((tab, index) => (
//           <div
//             key={index}
//             className={`tab1 ${activeTab === index ? 'active' : ''}`}
//             onClick={() => setActiveTab(index)}
//           >
//             <i className={tab.icon}></i>
//             {tab.label}
//           </div>
//         ))}
//       </div>
//       <div className="form-section active">
//         {renderForm()}
//       </div>
//     </div>
//   );
// };

// export default BookingForm;




































// const tabLabels = [
//   { icon: 'fas fa-hotel', label: 'HOTEL STAY' },
//   { icon: 'fas fa-building', label: 'APARTMENT STAY' },
//   { icon: 'fas fa-house-user', label: 'HOME STAY' },
//   { icon: 'fas fa-bed', label: 'HOSTELS' }
// ];





// import React, { useState, useEffect, useRef } from 'react';
// import './BookingForm.css';
// import { format, parseISO } from 'date-fns';
// import { useNavigate } from 'react-router-dom';





// const tabLabels = [
//   { icon: 'fas fa-hotel', label: 'Hotel Stay' },
// { icon: 'fas fa-building', label: 'Apartment Stay' },
// { icon: 'fas fa-house-user', label: 'Home Stay' },
// { icon: 'fas fa-bed', label: 'Hostels' }

// ];

// const formatDateDisplay = (dateStr) => {
//   const date = parseISO(dateStr);
//   return format(date, 'EEEE, dd MMMM yyyy');
// };

// const BookingForm = (props) => {
//   const [activeTab, setActiveTab] = useState(0);
//   const [popupVisible, setPopupVisible] = useState(false);
//   const [counts, setCounts] = useState({ rooms: 1, adults: 2, children: 0 });
//   const [destination, setDestination] = useState('');
//   // const [checkIn, setCheckIn] = useState('2025-07-10');
//   // const [checkOut, setCheckOut] = useState('2025-07-11');
//   const [error, setError] = useState('');
//   const [submittedData, setSubmittedData] = useState(null);

//   const today = new Date();
//   console.log(today)
//     // Format to YYYY-MM-DD
//   const formatDate = (date) => {
//     return date.toISOString().split("T")[0];
//   };

//   // Today
//   // const todayStr = formatDate(today);

//   // Tomorrow
//   const today1 = new Date();
//   today1.setDate(today.getDate() + 1);
//   const today2 = formatDate(today1);

//   const tomorrow = new Date();
//   tomorrow.setDate(today.getDate() + 2);
//   const tomorrowStr = formatDate(tomorrow);

//   const [checkIn, setCheckIn] = useState(today2);
//   const [checkOut, setCheckOut] = useState(tomorrowStr);



//   const popupRef = useRef();
//   const roomInfoRef = useRef();

// let history = useNavigate();

//   const updateCount = (type, delta) => {
//     setCounts(prev => {
//       const newCount = Math.max(type === 'rooms' ? 1 : 0, prev[type] + delta);
//       return { ...prev, [type]: newCount };
//     });
//   };

//   const handleClickOutside = (e) => {
//     if (
//       popupRef.current &&
//       !popupRef.current.contains(e.target) &&
//       roomInfoRef.current &&
//       !roomInfoRef.current.contains(e.target)
//     ) {
//       setPopupVisible(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener('mousedown', handleClickOutside);
//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, []);

//   const handleSearch = () => {
//     if (!destination || !checkIn || !checkOut) {
//       setError('All fields are required');
//       return;
//     }
//     setError('');

//       const data = {
//         destination,
//         checkIn,
//         checkOut,
//         rooms: counts.rooms,
//         adults: counts.adults,
//         children: counts.children,
//         selectedOption: tabLabels[activeTab].label
//       };

//       console.log('Form Data:', data);
//       localStorage.setItem(("BookingDate"),JSON.stringify(data))
//     history("/searchresults")

//   };

//   const renderForm = () => (
//     <>
//       <div className="input-group1">
//         <i className="fas fa-search"></i>
//         <input
//           type="text"
//           placeholder="Where would you like to go?"
//           value={destination}
//           onChange={(e) => setDestination(e.target.value)}
//         />
//       </div>

//       <div className="date-display">
//         <div className="date-box">
//           <label>Check-In</label>
//           <div className="date-formatted">{formatDateDisplay(checkIn)}</div>
//           <input
//             type="date"
//             value={checkIn}
//             onChange={(e) => setCheckIn(e.target.value)}
//           />
//         </div>
//         <div className="date-box">
//           <label>Check-Out</label>
//           <div className="date-formatted">{formatDateDisplay(checkOut)}</div>
//           <input
//             type="date"
//             value={checkOut}
//             onChange={(e) => setCheckOut(e.target.value)}
//           />
//         </div>
//       </div>

//       <div className="room-info1" ref={roomInfoRef} onClick={() => setPopupVisible(prev => !prev)}>
//         <span>
//           {counts.rooms} Room{counts.rooms > 1 ? 's' : ''}, {counts.adults} Adult{counts.adults > 1 ? 's' : ''}, {counts.children} Children
//         </span>
//         {popupVisible && (
//           <div className="popup1" ref={popupRef}>
//             {['rooms', 'adults', 'children'].map((type) => (
//               <div className="counter1" key={type}>
//                 <span>{type.charAt(0).toUpperCase() + type.slice(1)}</span>
//                 <div>
//                   <button onClick={(e) => { e.stopPropagation(); updateCount(type, -1); }}>-</button>
//                   <span>{counts[type]}</span>
//                   <button onClick={(e) => { e.stopPropagation(); updateCount(type, 1); }}>+</button>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
//       {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
//       <button className="search-btn1" onClick={handleSearch}>SEARCH</button>
//     </>
//   );

//   return (
//     <div className="container1">
//       <div className="tabs1">
//         {tabLabels.map((tab, index) => (
//           <div
//             key={index}
//             className={`tab1 ${activeTab === index ? 'active' : ''}`}
//             onClick={() => setActiveTab(index)}
//           >
//             <i className={tab.icon}></i>
//             {tab.label}
//           </div>
//         ))}
//       </div>
//       <div className="form-section active">
//         {renderForm()}
//       </div>
//       {submittedData && (
//         <div style={{ marginTop: '20px', background: '#f5f5f5', padding: '15px', borderRadius: '10px' }}>
//           <h4>Submitted Data:</h4>
//           <pre style={{ fontSize: '14px' }}>{JSON.stringify(submittedData, null, 2)}</pre>
//         </div>
//       )}
//     </div>
//   );
// };

// export default BookingForm;













































// import React, { useState, useEffect, useRef } from "react";
// import "./BookingForm.css";
// import { format, parseISO } from "date-fns";
// import { useNavigate } from "react-router-dom";




// // import { DateRange } from 'react-date-range';
// // import 'react-date-range/dist/styles.css'; 
// // import 'react-date-range/dist/theme/default.css'; 



// const tabLabels = [
//   { icon: "fas fa-hotel", label: "Hotel Stay" },
//   { icon: "fas fa-building", label: "Apartment Stay" },
//   { icon: "fas fa-house-user", label: "Home Stay" },
//   { icon: "fas fa-bed", label: "Hostels" },
// ];

// const formatDateDisplay = (dateStr) => {
//   const date = parseISO(dateStr);
//   return format(date, "EEEE, dd MMMM yyyy");
// };

// const BookingForm = () => {
//   const [activeTab, setActiveTab] = useState(0);
//   const [popupVisible, setPopupVisible] = useState(false);
//   const [counts, setCounts] = useState({ rooms: 1, adults: 2, children: 0 });
//   const [childrenAges, setChildrenAges] = useState([]);
//   const [destination, setDestination] = useState("");
//   const [error, setError] = useState("");

//   const today = new Date();
//   const formatDate = (date) => date.toISOString().split("T")[0];
//   const todayStr = formatDate(today);
//   const tomorrow = new Date();
//   tomorrow.setDate(today.getDate() + 1);
//   const tomorrowStr = formatDate(tomorrow);

//   const [checkIn, setCheckIn] = useState(todayStr);
//   const [checkOut, setCheckOut] = useState(tomorrowStr);
// //  const [range, setRange] = React.useState([
// //     {
// //       startDate: todayStr,
// //       endDate: tomorrowStr,
// //       key: 'selection'
// //     }
// //   ]);

//   const popupRef = useRef();
//   const roomInfoRef = useRef();
//   const navigate = useNavigate();

//   // Handle count updates
//   const updateCount = (type, delta) => {
//     setCounts((prev) => {
//       const newValue = Math.max(type === "rooms" ? 1 : 0, prev[type] + delta);
//       const updated = { ...prev, [type]: newValue };

//       if (type === "children") {
//         // Adjust children ages array dynamically
//         if (newValue > childrenAges.length) {
//           setChildrenAges((prevAges) => [
//             ...prevAges,
//             ...Array(newValue - prevAges.length).fill("0"),
//           ]);
//         } else {
//           setChildrenAges((prevAges) => prevAges.slice(0, newValue));
//         }
//       }
//       return updated;
//     });
//   };

//   // Outside click
//   const handleClickOutside = (e) => {
//     if (
//       popupRef.current &&
//       !popupRef.current.contains(e.target) &&
//       roomInfoRef.current &&
//       !roomInfoRef.current.contains(e.target)
//     ) {
//       setPopupVisible(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleSearch = () => {
    
//     if (!destination || !checkIn || !checkOut) {
//       setError("All fields are required");
//       return;
//     }
//     if (counts.adults === 0 || counts.rooms === 0) {
//       setError("Please select at least one room and one adult.");
//       return;
//     }

//     setError("");

//     const data = {
//       destination,
//       checkIn,
//       checkOut,
//       rooms: counts.rooms,
//       adults: counts.adults,
//       children: counts.children,
//       childrenAgesNeeded: childrenAges,
//       selectedOption: tabLabels[activeTab].label,
//     };

//     localStorage.setItem("BookingDate", JSON.stringify(data));
//     navigate("/searchresults");
//   };

//   const renderForm = () => (
//     <>
//       <div className="input-group1">
//         <i className="fas fa-search"></i>
//         <input
//           type="text"
//           placeholder="Where would you like to go?"
//           value={destination}
//           onChange={(e) => setDestination(e.target.value)}
//         />
//       </div>

//       {/* <div className="date-display">
//         <div className="date-box">
//            <div style={{ width: 'fit-content', margin: '40px auto' }}>
//       <DateRange
//         editableDateInputs={true}
//         onChange={item => setRange([item.selection])}
//         moveRangeOnFirstSelection={false}
//         ranges={range}
//       />
//     </div>
//         </div>
//       </div> */}
//       <div className="date-display">
//         <div className="date-box">
//           <label>Check-In</label>
//           <div className="date-formatted">{formatDateDisplay(checkIn)}</div>
//           <input
//             type="date"
//             value={checkIn}
//             onChange={(e) => setCheckIn(e.target.value)}
//           />
//         </div>
//         <div className="date-box">
//           <label>Check-Out</label>
//           <div className="date-formatted">{formatDateDisplay(checkOut)}</div>
//           <input
//             type="date"
//             value={checkOut}
//             onChange={(e) => setCheckOut(e.target.value)}
//           />
//         </div>
//       </div>

//       <div
//         className="room-info1"
//         ref={roomInfoRef}
//         onClick={() => setPopupVisible((prev) => !prev)}
//       >
//         <span>
//           {counts.rooms} Room{counts.rooms > 1 ? "s" : ""}, {counts.adults}{" "}
//           Adult{counts.adults > 1 ? "s" : ""},{" "}
//           {counts.children > 0
//             ? `${counts.children} Child${counts.children > 1 ? "ren" : ""}`
//             : "0 Children"}
//         </span>

//         {popupVisible && (
//   <div className="popup1" ref={popupRef} onClick={(e) => e.stopPropagation()}>
//     {["rooms", "adults", "children"].map((type) => (
//       <div className="counter1" key={type}>
//         <span>{type.charAt(0).toUpperCase() + type.slice(1)}</span>
//         <div>
//           <button
//             onClick={(e) => {
//               e.stopPropagation();
//               updateCount(type, -1);
//             }}
//           >
//             -
//           </button>
//           <span>{counts[type]}</span>
//           <button
//             onClick={(e) => {
//               e.stopPropagation();
//               updateCount(type, 1);
//             }}
//           >
//             +
//           </button>
//         </div>
//       </div>
//     ))}
//     {counts.children > 0 && (
//       <div className="children-ages">
//         <h4>Select Children Ages</h4>
//         {childrenAges.map((age, index) => (
//           <div className="age-row" key={index}>
//             <label style={{ width: "120px" }}>Child {index + 1} Age:</label>
//             <select
//               value={age}
//               onClick={(e) => e.stopPropagation()}
//               onChange={(e) => {
//                 e.stopPropagation();
//                 const newAges = [...childrenAges];
//                 newAges[index] = e.target.value;
//                 setChildrenAges(newAges);
//               }}
//             >
//               {Array.from({ length: 18 }, (_, i) => (
//                 <option key={i} value={i}>
//                   {i} year{i === 1 ? "" : "s"} old
//                 </option>
//               ))}
//             </select>
//           </div>
//         ))}
//       </div>
//     )}
//   </div>
// )}

//       </div>

//       {error && <div style={{ color: "red", marginBottom: "10px" }}>{error}</div>}

//       <button className="search-btn1" onClick={()=>handleSearch()}>
//         SEARCH
//       </button>
//     </>
//   );

//   return (
//     <div className="container1">
//       <div className="tabs1">
//         {tabLabels.map((tab, index) => (
//           <div
//             key={index}
//             className={`tab1 ${activeTab === index ? "active" : ""}`}
//             onClick={() => setActiveTab(index)}
//           >
//             <i className={tab.icon}></i>
//             {tab.label}
//           </div>
//         ))}
//       </div>
//       <div className="form-section active">{renderForm()}</div>
//     </div>
//   );
// };

// export default BookingForm;












// import React, { useState, useEffect, useRef } from "react";
// import "./BookingForm.css";
// import { format, parseISO } from "date-fns";
// import { useNavigate } from "react-router-dom";

// const tabLabels = [
//   { icon: "fas fa-hotel", label: "Hotel Stay" },
//   { icon: "fas fa-building", label: "Apartment Stay" },
//   { icon: "fas fa-house-user", label: "Home Stay" },
//   { icon: "fas fa-bed", label: "Hostels" },
// ];

// const formatDateDisplay = (dateStr) => {
//   const date = parseISO(dateStr);
//   return format(date, "EEEE, dd MMMM yyyy");
// };

// const BookingForm = () => {
//   const [activeTab, setActiveTab] = useState(0);
//   const [popupVisible, setPopupVisible] = useState(false);
//   const [counts, setCounts] = useState({ rooms: 1, adults: 2, children: 0 });
//   const [childrenAges, setChildrenAges] = useState([]);
//   const [destination, setDestination] = useState("");
//   const [error, setError] = useState("");

//   const today = new Date();
//   const formatDate = (date) => date.toISOString().split("T")[0];
//   const todayStr = formatDate(today);
//   const tomorrow = new Date();
//   tomorrow.setDate(today.getDate() + 1);
//   const tomorrowStr = formatDate(tomorrow);

//   const [checkIn, setCheckIn] = useState(todayStr);
//   const [checkOut, setCheckOut] = useState(tomorrowStr);

//   const popupRef = useRef();
//   const roomInfoRef = useRef();
//   const navigate = useNavigate();

//   // Handle count updates
//   const updateCount = (type, delta) => {
//     setCounts((prev) => {
//       const newValue = Math.max(type === "rooms" ? 1 : 0, prev[type] + delta);
//       const updated = { ...prev, [type]: newValue };

//       if (type === "children") {
//         // Adjust children ages array dynamically
//         if (newValue > childrenAges.length) {
//           setChildrenAges((prevAges) => [
//             ...prevAges,
//             ...Array(newValue - prevAges.length).fill("0"),
//           ]);
//         } else {
//           setChildrenAges((prevAges) => prevAges.slice(0, newValue));
//         }
//       }

//       return updated;
//     });
//   };

//   // Handle outside click
//   const handleClickOutside = (e) => {
//     if (
//       popupRef.current &&
//       !popupRef.current.contains(e.target) &&
//       roomInfoRef.current &&
//       !roomInfoRef.current.contains(e.target)
//     ) {
//       setPopupVisible(false);
//     }
//   };

//   useEffect(() => {
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   const handleSearch = () => {
//     if (!destination || !checkIn || !checkOut) {
//       setError("All fields are required");
//       return;
//     }

//     if (counts.adults === 0 || counts.rooms === 0) {
//       setError("Please select at least one room and one adult.");
//       return;
//     }

//     setError("");

//     const data = {
//       destination,
//       checkIn,
//       checkOut,
//       rooms: counts.rooms,
//       adults: counts.adults,
//       children: counts.children,
//       childrenAgesNeeded: childrenAges,
//       selectedOption: tabLabels[activeTab].label,
//     };

//     localStorage.setItem("BookingDate", JSON.stringify(data));
//     navigate("/searchresults");
//   };

//   const renderForm = () => (
//     <>
//       <div className="input-group1">
//         <i className="fas fa-search"></i>
//         <input
//           type="text"
//           placeholder="Where would you like to go?"
//           value={destination}
//           onChange={(e) => setDestination(e.target.value)}
//         />
//       </div>

//       <div className="date-display">
//         <div className="date-box">
//           <label>Check-In</label>
//           <div className="date-formatted">{formatDateDisplay(checkIn)}</div>
//           <input
//             type="date"
//             value={checkIn}
//             onChange={(e) => setCheckIn(e.target.value)}
//           />
//         </div>

//         <div className="date-box">
//           <label>Check-Out</label>
//           <div className="date-formatted">{formatDateDisplay(checkOut)}</div>
//           <input
//             type="date"
//             value={checkOut}
//             onChange={(e) => setCheckOut(e.target.value)}
//           />
//         </div>
//       </div>

//       <div
//         className="room-info1"
//         ref={roomInfoRef}
//         onClick={() => setPopupVisible((prev) => !prev)}
//       >
//         <span>
//           {counts.rooms} Room{counts.rooms > 1 ? "s" : ""},{" "}
//           {counts.adults} Adult{counts.adults > 1 ? "s" : ""},{" "}
//           {counts.children > 0
//             ? `${counts.children} Child${counts.children > 1 ? "ren" : ""}`
//             : "0 Children"}
//         </span>

//         {popupVisible && (
//           <div
//             className="popup1"
//             ref={popupRef}
//             onClick={(e) => e.stopPropagation()}
//           >
//             {["rooms", "adults", "children"].map((type) => (
//               <div className="counter1" key={type}>
//                 <span>
//                   {type.charAt(0).toUpperCase() + type.slice(1)}
//                 </span>
//                 <div>
//                   <button
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       updateCount(type, -1);
//                     }}
//                   >
//                     -
//                   </button>
//                   <span>{counts[type]}</span>
//                   <button
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       updateCount(type, 1);
//                     }}
//                   >
//                     +
//                   </button>
//                 </div>
//               </div>
//             ))}

//             {counts.children > 0 && (
//               <div className="children-ages">
//                 <h4>Select Children Ages</h4>
//                 {childrenAges.map((age, index) => (
//                   <div className="age-row" key={index}>
//                     <label style={{ width: "120px" }}>
//                       Child {index + 1} Age:
//                     </label>
//                     <select
//                       value={age}
//                       onClick={(e) => e.stopPropagation()}
//                       onChange={(e) => {
//                         e.stopPropagation();
//                         const newAges = [...childrenAges];
//                         newAges[index] = e.target.value;
//                         setChildrenAges(newAges);
//                       }}
//                     >
//                       {Array.from({ length: 18 }, (_, i) => (
//                         <option key={i} value={i}>
//                           {i} year{i === 1 ? "" : "s"} old
//                         </option>
//                       ))}
//                     </select>
//                   </div>
//                 ))}
//               </div>
//             )}
//           </div>
//         )}
//       </div>

//       {error && (
//         <div style={{ color: "red", marginBottom: "10px" }}>{error}</div>
//       )}

//       <button className="search-btn1" onClick={handleSearch}>
//         SEARCH
//       </button>
//     </>
//   );

//   return (
//     <div className="container1">
//       <div className="tabs1">
//         {tabLabels.map((tab, index) => (
//           <div
//             key={index}
//             className={`tab1 ${activeTab === index ? "active" : ""}`}
//             onClick={() => setActiveTab(index)}
//           >
//             <i className={tab.icon}></i> {tab.label}
//           </div>
//         ))}
//       </div>

//       <div className="form-section active">{renderForm()}</div>
//     </div>
//   );
// };

// export default BookingForm;






























import React, { useState, useEffect, useRef } from "react";
import "./BookingForm.css";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const tabLabels = [
  { icon: "fas fa-hotel", label: "Hotel Stay" },
  { icon: "fas fa-building", label: "Apartment Stay" },
  { icon: "fas fa-house-user", label: "Home Stay" },
  { icon: "fas fa-bed", label: "Hostels" },
];

const BookingForm = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [popupVisible, setPopupVisible] = useState(false);
  const [counts, setCounts] = useState({ rooms: 1, adults: 2, children: 0 });
  const [childrenAges, setChildrenAges] = useState([]);
  const [destination, setDestination] = useState("");
  const [error, setError] = useState("");

  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  // ✅ one state for range (both check-in & check-out)
  const [dateRange, setDateRange] = useState([today, tomorrow]);
  const [checkIn, checkOut] = dateRange;

  const popupRef = useRef();
  const roomInfoRef = useRef();
  const navigate = useNavigate();

  const updateCount = (type, delta) => {
    setCounts((prev) => {
      const newValue = Math.max(type === "rooms" ? 1 : 0, prev[type] + delta);
      const updated = { ...prev, [type]: newValue };

      if (type === "children") {
        if (newValue > childrenAges.length) {
          setChildrenAges((prevAges) => [
            ...prevAges,
            ...Array(newValue - prevAges.length).fill("0"),
          ]);
        } else {
          setChildrenAges((prevAges) => prevAges.slice(0, newValue));
        }
      }

      return updated;
    });
  };

  const handleClickOutside = (e) => {
    if (
      popupRef.current &&
      !popupRef.current.contains(e.target) &&
      roomInfoRef.current &&
      !roomInfoRef.current.contains(e.target)
    ) {
      setPopupVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ✅ format date helper
  // const formatDate = (date) => {
  //   if (!date) return "";
  //   const options = { day: "2-digit", month: "short", year: "numeric" };
  //   return date.toLocaleDateString("en-US", options);
  // };

  // ✅ format date as dd-MMM-yyyy
// const formatDate = (date) => {
//   if (!date) return "";
//   const day = String(date.getDate()).padStart(2, "0");
//   const month = date.toLocaleString("en-US", { month: "short" });
//   const year = date.getFullYear();
//   return `${day}-${month}-${year}`;
// };

  const formatDate = (date) => {
    if (!date) return "";
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 0-based month
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  const handleSearch = () => {
    if (!destination || !checkIn || !checkOut) {
      setError("All fields are required");
      return;
    }

    if (counts.adults === 0 || counts.rooms === 0) {
      setError("Please select at least one room and one adult.");
      return;
    }

    setError("");

    const data = {
      destination,
      checkIn: formatDate(checkIn),
      checkOut: formatDate(checkOut),
      rooms: counts.rooms,
      adults: counts.adults,
      children: counts.children,
      childrenAgesNeeded: childrenAges,
      selectedOption: tabLabels[activeTab].label,
    };

    localStorage.setItem("BookingDate", JSON.stringify(data));
 navigate("/searchresults");

  };

  const renderForm = () => (
    <>
      <div className="input-group1">
        <i className="fas fa-search"></i>
        <input
          type="text"
          placeholder="Where would you like to go?"
          value={destination}
          onChange={(e) => setDestination(e.target.value)}
        />
      </div>

      <div className="date-display single-picker">
        <label>Select Your Stay Dates</label>
        <DatePicker
          selectsRange={true}
          startDate={checkIn}
          endDate={checkOut}
          onChange={(update) => setDateRange(update)}
          isClearable={true}
          minDate={new Date()}
          dateFormat="EEE, dd MMM yyyy"
          placeholderText="Select check-in and check-out"
        />
      </div>

      <div
        className="room-info1"
        ref={roomInfoRef}
        onClick={() => setPopupVisible((prev) => !prev)}
      >
        <span>
          {counts.rooms} Room{counts.rooms > 1 ? "s" : ""},{" "}
          {counts.adults} Adult{counts.adults > 1 ? "s" : ""},{" "}
          {counts.children > 0
            ? `${counts.children} Child${counts.children > 1 ? "ren" : ""}`
            : "0 Children"}
        </span>

        {popupVisible && (
          <div
            className="popup1"
            ref={popupRef}
            onClick={(e) => e.stopPropagation()}
          >
            {["rooms", "adults", "children"].map((type) => (
              <div className="counter1" key={type}>
                <span>{type.charAt(0).toUpperCase() + type.slice(1)}</span>
                <div>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      updateCount(type, -1);
                    }}
                  >
                    -
                  </button>
                  <span>{counts[type]}</span>
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      updateCount(type, 1);
                    }}
                  >
                    +
                  </button>
                </div>
              </div>
            ))}

            {counts.children > 0 && (
              <div className="children-ages">
                <h4>Select Children Ages</h4>
                {childrenAges.map((age, index) => (
                  <div className="age-row" key={index}>
                    <label style={{ width: "120px" }}>Child {index + 1} Age:</label>
                    <select
                      value={age}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => {
                        e.stopPropagation();
                        const newAges = [...childrenAges];
                        newAges[index] = e.target.value;
                        setChildrenAges(newAges);
                      }}
                    >
                      {Array.from({ length: 18 }, (_, i) => (
                        <option key={i} value={i}>
                          {i} year{i === 1 ? "" : "s"} old
                        </option>
                      ))}
                    </select>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      {error && <div style={{ color: "red", marginBottom: "10px" }}>{error}</div>}

      <button className="search-btn1" onClick={handleSearch}>
        SEARCH
      </button>
    </>
  );

  return (
    <div className="container1">
      <div className="tabs1">
        {tabLabels.map((tab, index) => (
          <div
            key={index}
            className={`tab1 ${activeTab === index ? "active" : ""}`}
            onClick={() => setActiveTab(index)}
          >
            <i className={tab.icon}></i> {tab.label}
          </div>
        ))}
      </div>

      <div className="form-section active">{renderForm()}</div>
    </div>
  );
};

export default BookingForm;
